import { useEffect } from "react";
import { API_ADMIN_URL } from "../config/constants";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { notification } from "antd";
import {
    InfoCircleOutlined,
  } from "@ant-design/icons";

export const checkSession = async (authToken) => {
    try {
      const response = await axios.get(API_ADMIN_URL+'users/check-session', {
        headers: {
          'authtoken': authToken,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };


  export const useSessionCheck = (authToken) => {
    const navigate = useNavigate();
  
    useEffect(() => {
      if (!authToken) return; // Exit if there's no authToken
  
      const checkUserSession = async () => {
        try {
          await checkSession(authToken);
        } catch (error) {
          console.error("Session check error:", error);
          
          if (error.response?.status === 500) {
            sessionStorage.removeItem("TOKEN");
            sessionStorage.setItem("session", "true");
            navigate("/", { state: { message: "Session expired! Please re-login." } });
          }
        }
      };
  
      checkUserSession(); // Run immediately when mounted
  
      // Optional: If you want to check the session periodically, uncomment the below lines
      // const interval = setInterval(checkUserSession, 10000); // Check every 10s
      // return () => clearInterval(interval); // Cleanup interval on unmount
  
    }, [authToken, navigate]);
  };


//   export const useInactivityTimeout = (timeoutDuration, onExpire) => {
//     useEffect(() => {
//       let inactivityTimer;
  
//       const resetTimer = () => {
//         clearTimeout(inactivityTimer);
//         inactivityTimer = setTimeout(onExpire, timeoutDuration);
//       };
  
//       window.addEventListener('mousemove', resetTimer);
//       window.addEventListener('keydown', resetTimer);
  
//       resetTimer();
  
//       return () => {
//         window.removeEventListener('mousemove', resetTimer);
//         window.removeEventListener('keydown', resetTimer);
//         clearTimeout(inactivityTimer);
//       };
//     }, [timeoutDuration, onExpire]);
//   };
  


     // notification.open({
            //     message: "Opps!",
            //     description: `Your session has expired. Please log in again`,
            //     placement: "topRight",
            //     icon: <InfoCircleOutlined style={{ color: "red" }} />,
            //   });
            //   navigate('/', { state: { message: "Session expired! Please re-login." } });

            // alert('Your session has expired. Please log in again.');